export default __webpack_public_path__ + "static/media/cash-out-your-way-3.b9bc68db.png";